import { fetchApi, ADMIN_API } from '@/api/client'
import type { RunDetail, RunHeader, TableRow, TriggerResponse } from '../types'

const BASE = `${ADMIN_API}/admin/parity`

/** Most recent COMPLETED run for this deployment's environment, or null if none yet (404). */
export async function getLatestRun(): Promise<RunDetail | null> {
  try {
    return await fetchApi<RunDetail>(`${BASE}/latest`)
  } catch (err) {
    if (err instanceof Error && err.message.startsWith('API Error 404')) return null
    throw err
  }
}

/** Run headers, newest first. */
export async function getRuns(limit = 48): Promise<RunHeader[]> {
  return fetchApi<RunHeader[]>(`${BASE}/runs?limit=${limit}`)
}

export async function getRun(runId: string): Promise<RunDetail> {
  return fetchApi<RunDetail>(`${BASE}/runs/${runId}`)
}

/** One table across recent runs, newest first — for the trend view. */
export async function getTableHistory(accId: number, table: string, limit = 48): Promise<TableRow[]> {
  const q = new URLSearchParams({ accId: String(accId), table, limit: String(limit) })
  return fetchApi<TableRow[]>(`${BASE}/history?${q}`)
}

/** Starts a run in the background; 409 → started=false. */
export async function triggerRun(): Promise<TriggerResponse> {
  return fetchApi<TriggerResponse>(`${BASE}/trigger`, { method: 'POST' })
}
